// Copyright (c) 2017 Deere & Company

import LaborStatsReport from '../../../reports/labor-stats/state-connector';

export default {
    component: LaborStatsReport,
    name: 'LABOR_STATS',
    path: 'labor-stats'
};



// WEBPACK FOOTER //
// ./src/routes/claims/reports/labor-stats.js